import { render, staticRenderFns } from "./CreateInstruction.vue?vue&type=template&id=25acf76e"
import script from "./CreateInstruction.vue?vue&type=script&lang=js"
export * from "./CreateInstruction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports